import React, { useState } from "react";
import "./SubmitButtonModal.css";

function SubmitButtonModal({ show, onClose, onSave, submitButton }) {
  const [buttonText, setButtonText] = useState(submitButton.text);
  const [buttonColor, setButtonColor] = useState(submitButton.color);
  const [textColor, setTextColor] = useState(submitButton.textColor || "#ffffff");

  if (!show) return null;

  const handleSave = () => {
    onSave({ text: buttonText, color: buttonColor, textColor });
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <h2>Edit Submit Button</h2>
        
        <div className="form-group">
          <label>Button Text:</label>
          <input type="text" value={buttonText} onChange={(e) => setButtonText(e.target.value)} />
        </div>

        <div className="form-group">
          <label>Button Background Color:</label>
          <input type="color" value={buttonColor} onChange={(e) => setButtonColor(e.target.value)} />
        </div>

        <div className="form-group">
          <label>Button Text Color:</label>
          <input type="color" value={textColor} onChange={(e) => setTextColor(e.target.value)} />
        </div>

        <div className="modal-footer">
          <button className="btn close-btn" onClick={onClose}>Cancel</button>
          <button className="btn save-btn" onClick={handleSave}>Save</button>
        </div>
      </div>
    </div>
  );
}

export default SubmitButtonModal;
